import React, { createContext, useState } from 'react'

export const BlogContext = createContext({
    article: {},
    handleArticle: () => {}
})

const BlogContextProvider = ({children}) => {
  const [article, setArticle] = useState({})
  
  const handleArticle = (article) => {
      setArticle(article)
  }
  return (
    <BlogContext.Provider value={{article: article, handleArticle: handleArticle}}>
        {children}
    </BlogContext.Provider>
  )
}

export default BlogContextProvider